import React from 'react';
import AssignmentActionFlowModal, {
	ActionTarget,
	ActionTargetOption,
	ActionSummary
} from '../AssignmentActionFlowModal';

export type ResetTarget = ActionTarget;

const RESET_OPTIONS: ActionTargetOption[] = [
	{
		value: 'all',
		title: 'All previously selected users',
		description:
			'Reset this training for all users included in the last assignment.'
	},
	{
		value: 'specific',
		title: 'Specific users',
		description:
			'Reset this training for selected users only, based on property, group or individual selection.'
	}
];

const plural = (count: number, noun: string) =>
	`${count} ${noun}${count === 1 ? '' : 's'}`;

const resetSpecificItems = ({
	entityCount,
	userCount
}: ActionSummary): string[] => [
	...(entityCount ? [`Affect ${plural(entityCount, 'selection')}`] : []),
	`Reset progress for ${plural(userCount, 'learner')}`
];

interface ResetCompletionModalProps {
	visible: boolean;
	assignmentId: number;
	scopes: string[];
	tenantId?: number;
	onCancel: () => void;
	onContinue: (target: ResetTarget, userIds?: string[]) => void | Promise<void>;
}

const ResetCompletionModal: React.FC<ResetCompletionModalProps> = ({
	visible,
	assignmentId,
	scopes,
	tenantId,
	onCancel,
	onContinue
}) => (
	<AssignmentActionFlowModal
		visible={visible}
		assignmentId={assignmentId}
		scopes={scopes}
		tenantId={tenantId}
		audience
		onCancel={onCancel}
		onContinue={onContinue}
		select={{
			title: 'Reset training',
			description: 'Choose who you want to reset this training from.',
			options: RESET_OPTIONS,
			actionLabel: 'Continue'
		}}
		confirmAll={{
			title: 'Reset training?',
			intro: 'Resetting this training will:',
			items: ({ userCount }) => [
				`Reset progress for ${plural(userCount, 'learner')}`
			],
			actionLabel: 'Reset'
		}}
		specific={{
			title: 'Reset specific users',
			description: 'Review and update who will take this training',
			actionLabel: 'Continue'
		}}
		confirmSpecific={{
			title: 'Confirm reset',
			intro: 'Resetting this training will:',
			items: resetSpecificItems,
			actionLabel: 'Reset'
		}}
	/>
);

export default ResetCompletionModal;
